type BillingStore = {
  id?: string;
  store?: string | null;
  domain?: string | null;
  type?: string | null;
  useCustomApp?: boolean | null;
  billing?: unknown;
  plan?: { chargeConfirmed?: unknown } | null;
};

const approvedPublicStores = new Map([
  ['9fcffee8-86f4-4795-bfb0-47514c32296a', 'beatmerchshop.myshopify.com'],
  ['88abbcda-a034-4066-a97a-6c352c2fa9d6', 'sound-rink.myshopify.com'],
]);

// Reviewed 2026-11-04. The actual shared-customer owner retains its existing card controls.
const approvedCustomStores = new Map([
  ['0cc2f30b-8c3c-40b2-8c93-2b93d0399a2c', '455ea4-2.myshopify.com'],
  ['48b306d4-049e-429a-87a2-d686e85736cf', 'after-the-burial.myshopify.com'],
  ['11ea7454-e012-4f69-851c-1d471a6c1764', 'amity-affliction.myshopify.com'],
  ['11e8f6c3-ac18-4ceb-a34e-7fe52baf55f2', 'blowed-out-records.myshopify.com'],
  ['6b07ae1f-8ad9-4b94-b8b7-d295ff199e70', 'brand-of-sacrifice.myshopify.com'],
  ['84ea130b-5cac-4c18-a838-70ecd68255c1', 'bufferingthevampireslayer.myshopify.com'],
  ['44849d53-6d3e-4fca-8bb6-163b6dc8ecea', 'carlie-hanson.myshopify.com'],
  ['83af81f8-9477-449f-b912-86e16813fbd6', 'cavecanarygoods.myshopify.com'],
  ['88f8de20-264c-4b3a-b1ed-18a8adc2eb75', 'congratsrecords.myshopify.com'],
  ['01859780-2f01-474f-b7a8-3a3d8fa9ac42', 'crown-the-empire-store.myshopify.com'],
  ['36fba472-598d-481f-955a-376eea368b58', 'equal-vision-records.myshopify.com'],
  ['79847e96-32b2-4676-87d1-a64b14c4e366', 'fat-wreck-chords.myshopify.com'],
  ['1ba849b5-473f-4316-b36b-7a8814d34a02', 'ferret-music.myshopify.com'],
  ['c39af9a6-1dc3-4e30-8272-8f721094f764', 'goodfightmusic.myshopify.com'],
  ['618edc34-99af-4799-ab75-c5abee376265', 'honey-revenge.myshopify.com'],
  ['7090e3db-8ea7-468a-a644-96b75ba4ddd2', 'hopelessrecords.myshopify.com'],
  ['78dc6354-b926-4430-b13c-16cae43c27b4', 'invoguemerchandise.myshopify.com'],
  ['c4cc75e3-5cd2-42fd-a795-9bfdba53b1be', 'itsjvke.myshopify.com'],
  ['d200103d-477a-40c2-9162-b79afedf76af', 'jtmetw-rb.myshopify.com'],
  ['c17fe13c-23cc-4181-8fd9-a3a5bb2ffc8c', 'kittie-merch.myshopify.com'],
  ['0a98f632-b4b9-4232-a018-d81cdc04fb51', 'mayday-parade.myshopify.com'],
  ['60a9727a-bf5a-4699-a259-4b9739c5bf16', 'merchnext.myshopify.com'],
  ['56dc861a-cd9c-4493-9997-71ac0a99c045', 'merchnowmall.myshopify.com'],
  ['993c8417-323e-4415-a2a3-f8deef673752', 'missmayimerch.myshopify.com'],
  ['2cf8316b-fb84-4f6c-b0d8-ddfcd3286494', 'nmzine.myshopify.com'],
  ['dd8a26c2-c6ae-4219-98f6-49ad50fe4720', 'palechord.myshopify.com'],
  ['02a6c90b-b6c4-4e2d-b9fd-bb58e1cc3c58', 'piratespress.myshopify.com'],
  ['ce1e9ced-c4db-4b44-91bf-8a478cd61cfd', 'pure-noise-merch.myshopify.com'],
  ['5373f894-29f7-472f-8dd4-7ed4ee61ccaa', 'redjumpsuitapparatus.myshopify.com'],
  ['e84fae01-c462-4bee-b960-640660edfe3d', 'rise-records.myshopify.com'],
  ['0463b4a2-2f90-4f42-8c92-ef5d20f10fdd', 'sadistik-merch.myshopify.com'],
  ['fdb97cc7-34cc-434f-bb89-19e3cb25800c', 'shop-bayside.myshopify.com'],
  ['0af63ade-7501-41fc-ab0c-51e2c9ea5690', 'shop-facedown.myshopify.com'],
  ['069f5b33-77a2-438b-935b-60dee6509d22', 'shop-raincitydrive.myshopify.com'],
  ['d244cf9c-073d-4bac-987a-308b8d0aaed0', 'sleepingwithsirens.myshopify.com'],
  ['15f8737e-1b1f-44b2-a9de-e9ead10a8fba', 'spinefarm-records.myshopify.com'],
  ['cfd5952e-9622-4e8e-b9f4-e508dc6a31bb', 'starcrawler-music.myshopify.com'],
  ['226cb42f-0bc3-48f1-9162-7ed7875339d0', 'stevevai.myshopify.com'],
  ['9332b516-b47f-46cf-81d4-d0cbbbf17705', 'tabitha-brown.myshopify.com'],
  ['b3660e6e-d0e9-4a0e-967a-d538346177d6', 'tayloracornmerch.myshopify.com'],
  ['e3c9fb4d-bbd9-47ec-9496-71cecbfadc8b', 'teenage-bottlerocket-merch.myshopify.com'],
  ['68d1d1cc-5dd9-45d8-a639-766824447795', 'thefrontbottomsstore.myshopify.com'],
  ['e8a1b5c0-ce4a-470e-80c8-a180c49bf4a8', 'theholdsteady.myshopify.com'],
  ['f331bf16-e64f-4213-9c50-a28dea8e6c31', 'the-linda-lindas.myshopify.com'],
  ['3aef5e8f-c205-4855-801f-11e75371652d', 'theweeksmerch.myshopify.com'],
  ['ecdab152-8705-4da6-a7ae-06fa0bbb8f76', 'thrillerrecords.myshopify.com'],
  ['3e40c7d7-08e0-47ac-ba79-a0654f9a5843', 'tinashe-shop.myshopify.com'],
  ['b7fea628-e3ff-4c01-a8c5-7b50a435dd3c', 'trustrecordscompany.myshopify.com'],
  ['a0a02730-2e5a-431c-9cfc-e68b5b3a7cf1', 'tsunamisea.myshopify.com'],
  ['4b63d340-85df-49fb-87f5-1f3cd26b0530', 'usa-peaceville.myshopify.com'],
  ['7b331802-e983-439f-99c9-7332b0cf4d11', 'veilofmaya.myshopify.com'],
  ['3a68c49e-bd27-44db-a14e-522f0702fb72', 'velocity-records.myshopify.com'],
  ['1d95a56d-5373-43ac-9e45-c6de6fa59452', 'whitechapel-store.myshopify.com'],
  ['95835bc7-c05b-4912-b15e-48288d1def63', 'yellowcardstore.myshopify.com'],
]);

const object = (value: unknown): Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};

export const isMerchNowManagedBilling = (store?: BillingStore | null): boolean => {
  if (!store || store.type !== 'SHOPIFY') return false;
  const custom = store.useCustomApp === true;
  if (!custom && store.useCustomApp !== false && store.useCustomApp !== null) return false;
  const domain = store.id ? (custom ? approvedCustomStores : approvedPublicStores).get(store.id) : undefined;
  const billing = object(store.billing);
  if (domain === 'merchnowmall.myshopify.com') return false;
  const providerMatches = billing.provider === 'STRIPE_BILLING' ||
    (custom && (billing.provider === undefined || billing.provider === null));
  return Boolean(
    domain && store.store === domain && (!store.domain || store.domain === domain) &&
      providerMatches &&
      object(billing.customer).id === 'cus_RkslZgmGGtYM12',
  );
};

export const usesStripeBilling = (store?: BillingStore | null): boolean =>
  Boolean(store?.useCustomApp || isMerchNowManagedBilling(store));

export const hasConnectedBilling = (store?: BillingStore | null): boolean =>
  Boolean(store?.plan?.chargeConfirmed || (usesStripeBilling(store) && store?.billing));
